import { createContext, ReactElement, ReactNode, useContext } from 'react'

import { Contact } from '@features/contacts/types/contact'
import { ShippingAddress } from '@features/contacts/types/shippingAddress'

interface ContextState {
  contact: Contact
  shippingAddress: ShippingAddress | undefined
}

interface ContactDetailContextProps {
  children: ReactNode
  contact: Contact
  shippingAddress: ShippingAddress | undefined
}

const ContactDetailContext = createContext<ContextState | undefined>(undefined)

export const ContactDetailContextProvider = ({
  children,
  contact,
  shippingAddress,
}: ContactDetailContextProps): ReactElement => {
  return <ContactDetailContext.Provider value={{ contact, shippingAddress }}>{children}</ContactDetailContext.Provider>
}

export const useContactDetail = () => {
  const context = useContext(ContactDetailContext)

  if (!context) {
    throw new Error('ContactDetailContextProvider is missing in the module!')
  }

  return context
}
